import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router';

import * as Actions from '../customer-detail/documents/store/customer-detail-documents-actions';
import * as Selectors from '../customer-detail/documents/store/customer-detail-documents-selectors';
import { PaloRecordDocuments } from '../../../../common/components/palo/palo-record-documents';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

/** The member's documents, for the rail of its mask. */
export const PaloCustomerDocuments = (): ReactElement => {
    const dispatch = useThunkDispatch();
    const { id } = useParams<{ id: string }>();
    const documents = useAppSelector(Selectors.documentsSelector);
    const downloadBaseUrl = useAppSelector(state => state.settings.privateFilesystemPath);

    useEffect(() => {
        if (id && +id) {
            dispatch(Actions.fetchCustomerDocuments(+id));
        }
    }, [dispatch, id]);

    return (
        <PaloRecordDocuments
            documents={documents}
            downloadBaseUrl={downloadBaseUrl}
            onAdd={(files, titles) => {
                const fresh = files
                    .map((file, index) => ({ file, title: titles[index] }))
                    .filter(
                        ({ file }) => !documents.some(doc => doc.originalName === file.name && doc.size === file.size)
                    );

                if (fresh.length > 0) {
                    dispatch(
                        Actions.addCustomerDocuments(
                            fresh.map(entry => entry.file),
                            fresh.map(entry => entry.title ?? '')
                        )
                    );
                }
            }}
            // A document always carries a title; cleared, it goes back to the file name.
            onRename={(document, title) =>
                dispatch(Actions.renameDocument(document.id, title.trim() || document.originalName || ''))
            }
            onRemove={document => dispatch(Actions.deleteDocument(document.id))}
        />
    );
};
